const setImageAbsoluteUrl = (url) => {
    if (!url) return url;
    if (url.startsWith("http")) return url;
    const newURL = process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}${url}` : `https://pr-web-wordpress-egd6bfcbb4enatax.eastus-01.azurewebsites.net${url}`;
    return  newURL;
}

export default setImageAbsoluteUrl;